<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.SERVICES.OPTIONS.SELECTED"
    :handler="
      () =>
        $stores.services?.state?.transactionInitiation?.service?.id ==
          'giftCard' &&
        $stores.services?.state?.transactionInitiation?.operation?.id ==
          'sell' &&
        $refs.modal.show()
    "
  />
  <VBusHelper
    :reactOn="$constants.EVENTS.SERVICES.CLOSE_OPERATION_INITIATION"
    :handler="() => $refs.modal.hide()"
  />

  <DialogComponent
    ref="modal"
    type="bottomsheet"
    mainClass="fixed z-[52]"
    hideCloseButton
    @closed="
      ({ source }) =>
        source !== 'external' &&
        $bus.emit($constants.EVENTS.SERVICES.CLOSE_SERVICE_INITIATION)
    "
  >
    <div class="p-6 flex flex-col gap-8">
      <form
        class="w-full grid grid-cols-12 gap-4"
        v-bus:EVENTS.SERVICES.INITIATION.SUBMIT_FORM.submit.prevent
      >
        <!-- Type de carte -->
        <div class="col-span-12 flex flex-col">
          <label class="mb-1">Type de carte</label>
          <select
            class="p-4 border rounded-xl border-neutral-200 focus:border-primary-400 w-full"
            v-model="$stores.services.state.transactionInitiation.cardType"
            required
          >
            <option value="amazon">Amazon</option>
            <option value="netflix">Netflix</option>
            <option value="spotify">Spotify</option>
            <option value="itunes">iTunes</option>
            <option value="google">Google Play</option>
          </select>
        </div>

        <!-- Montant -->
        <div class="col-span-12 flex flex-col">
          <label class="mb-1">Montant</label>
          <input
            v-model="
              $stores.services.state.transactionInitiation.recipientAmount
            "
            type="number"
            required
            class="p-4 border rounded-xl border-neutral-200 focus:border-primary-400 w-full"
          />
          <small class="text-gray-500">Minimum : 500 CFA</small>
        </div>

        <!-- Mode de paiement -->
        <div class="col-span-12 flex flex-col">
          <label class="mb-1">Mode de retrait</label>
          <select
            class="p-4 border rounded-xl border-neutral-200 focus:border-primary-400 w-full"
            v-model="$stores.services.state.transactionInitiation.paymentMethod"
            required
          >
            <option
              v-for="(option, i) in $constants.SERVICES.PAYMENT_METHODS"
              :value="option"
              :key="i"
            >
              {{ option.name }}
            </option>
          </select>
        </div>

        <!-- Numéro de téléphone -->
        <div class="col-span-12 flex flex-col">
          <label class="mb-1">Téléphone</label>
          <div class="relative w-full">
            <input
              v-model="
                $stores.services.state.transactionInitiation.senderPhoneNumber
              "
              required
              type="text"
              inputmode="numeric"
              pattern="[0-9]{8,}"
              class="p-4 border rounded-xl border-neutral-200 focus:border-primary-400 w-full pr-24"
              placeholder="Ex: 61020304"
              ref="phoneNumberInput"
            />
            <div
              class="absolute right-3 top-1/2 -translate-y-1/2 flex items-center gap-2"
            >
              <PhoneDetail
                :phoneNumber="
                  $stores.services.state.transactionInitiation.senderPhoneNumber
                "
                :countryCode="$stores.user.state.current?.countryCode"
                @loading="
                  (data) => {
                    $refs.phoneNumberInput.setCustomValidity('chargement');
                    $stores.services.state.transactionInitiation.phoneOperator =
                      '';
                  }
                "
                @resolved="
                  (data) => {
                    $refs.phoneNumberInput.setCustomValidity('');
                    $stores.services.state.transactionInitiation.phoneOperator =
                      data.carrier;
                  }
                "
                @error="
                  (data) => {
                    $stores.services.state.transactionInitiation.phoneOperator =
                      '';
                    $refs.phoneNumberInput.setCustomValidity(
                      `Erreur du numéro: ${data.error}`
                    );
                  }
                "
                v-slot="{ carrier, logoUrl }"
              >
                <img
                  v-if="logoUrl"
                  :src="logoUrl"
                  class="w-8 h-5 object-contain"
                  alt=""
                />
                <span v-else class="text-xs text-gray-500">{{ carrier }}</span>
              </PhoneDetail>
            </div>
          </div>
        </div>

        <!-- Code de la carte -->
        <div class="col-span-12 flex flex-col">
          <label class="mb-1">Code de la carte</label>
          <input
            v-model="$stores.services.state.transactionInitiation.cardCode"
            type="text"
            required
            class="p-4 border rounded-xl border-neutral-200 focus:border-primary-400 w-full"
            placeholder="Entrez le code de la carte"
          />
        </div>

        <!-- Bouton résumé -->
        <div class="col-span-12">
          <div
            class="p-4 rounded text-white"
            style="background-color: #e76f51d4"
          >
            <div class="text-lg">Nous allons vendre des cartes cadeaux</div>
          </div>

          <!-- summary -->
          <div class="mt-4">
            <ShortSummary />
          </div>

          <!-- buttons section -->
          <div class="flex flex-col gap-3 mt-4">
            <button
              :disabled="
                $stores.services?.state?.transactionInitiationFees
                  ?.loadingFees || $stores.services?.state?.initiatingPayment
              "
              :class="{
                'opacity-50':
                  $stores.services?.state?.transactionInitiationFees
                    ?.loadingFees || $stores.services?.state?.initiatingPayment
              }"
              class="w-full flex items-center justify-center gap-2 text-white p-4 rounded font-semibold transition-all"
              style="background-color: #e76f51"
              type="submit"
            >
              <span
                v-if="
                  !$stores.services?.state?.transactionInitiationFees
                    ?.loadingFees && !$stores.services?.state?.initiatingPayment
                "
              >
                Continuer
              </span>
              <span v-else class="flex items-center gap-2">
                <svg
                  class="animate-spin"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="3"
                    class="opacity-25"
                  />
                  <path
                    fill="currentColor"
                    class="opacity-75"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  />
                </svg>
                Traitement...
              </span>
              <svg
                v-if="
                  !$stores.services?.state?.transactionInitiationFees
                    ?.loadingFees && !$stores.services?.state?.initiatingPayment
                "
                class="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                />
              </svg>
            </button>

            <button
              v-if="$stores.services?.state?.initiatingPayment"
              type="button"
              @click="
                $bus.emit($constants.EVENTS.SERVICES.CLOSE_SERVICE_INITIATION)
              "
              class="w-full py-3 text-red-600 font-bold border-2 border-red-100 rounded-xl hover:bg-red-50 transition-colors flex items-center justify-center gap-2"
            >
              Annuler la transaction
            </button>
          </div>
        </div>
      </form>
    </div>
  </DialogComponent>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SellGiftCardForm'
});
</script>

